export enum Enum_BranchesInfoFilter {
  all = "",
  clinic = "clinic",
  laboratory = "laboratory",
}

export enum Enum_BranchesInfoRegionFilters {
  all = 2,
  tbilisi = 0,
  regions = 1,
}
